"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _ImpactDataCallout = _interopRequireDefault(require("../../components/ImpactDataCallout/ImpactDataCallout"));
var _ = require("../..");
var _PageGrid = _interopRequireDefault(require("../../layouts/Skeletons/PageGrid/PageGrid"));
var _excluded = ["headingCopyObject", "DataPointOne", "DataPointTwo"];
var _templateObject, _templateObject2;
var StyledSectionHeading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    h1: true,
    pink: true,
    className: className
  }, " ", children, " ");
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledSectionSubheading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  return _react.default.createElement(_Heading.default, {
    h3: true,
    darkGrey: true,
    special: true,
    className: className
  }, " ", children, " ");
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n  margin-bottom: 20px !important;\n"])));
var Impact = function Impact(_ref3) {
  var headingCopyObject = _ref3.headingCopyObject,
    DataPointOne = _ref3.DataPointOne,
    DataPointTwo = _ref3.DataPointTwo,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return _react.default.createElement(_PageGrid.default, props, _react.default.createElement(_Grid.default, Object.assign({
    container: true
  }, props), _react.default.createElement(_.HorizontalDivider, null), _react.default.createElement(_Grid.default, Object.assign({
    item: true,
    justifyContent: "center",
    style: {
      textAlign: 'center'
    }
  }, props), _react.default.createElement(StyledSectionHeading, Object.assign({
    xs: 12
  }, props), headingCopyObject.header), _react.default.createElement(StyledSectionSubheading, Object.assign({
    xs: 12
  }, props), headingCopyObject.subheader)), _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    justifyContent: "center"
  }, props), _react.default.createElement(_ImpactDataCallout.default, Object.assign({
    xs: 12,
    sm: 12,
    md: 12,
    lg: 5
  }, props, {
    dataPoint: DataPointOne.header,
    dataDescription: DataPointOne.subheader
  })), _react.default.createElement(_ImpactDataCallout.default, Object.assign({
    xs: 12,
    sm: 12,
    md: 12,
    lg: 7
  }, props, {
    dataPoint: DataPointTwo.header,
    dataDescription: DataPointTwo.subheader
  }))), _react.default.createElement(_.HorizontalDivider, null)));
};
var _default = Impact;
exports.default = _default;